module.exports = __webpack_public_path__ + "static/media/North-Lexington-Condos-bylaws.480646f2.pdf";